/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ReviewTransactionRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {ReviewTransactionResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const reviewTransaction = (request: ReviewTransactionRequest, options?: CashRequestOptions) => post<ReviewTransactionRequest, ReviewTransactionResponse>("/2.0/cash/review-transaction", request, {...options, rejectOnError: true })